
// ---------------------------------------------------------
// Base URL for THIS deployment (admin, local/dev/live)
// ---------------------------------------------------------
export const domain = window.ekno_base_url || 'local.powerprep.eknowledge.com:4043';
export const base_url = location.protocol + '//' + domain;
const local_url = 'local.powerprep.eknowledge.com';

// ---------------------------------------------------------
// Internal constants for calculating base URLs
// ---------------------------------------------------------
export const root_domain = domain.search('ekno') !== -1 ? 'powerprep10.eknowledge.com' : 'nctpf.org';
const env_subdomain = domain.search('dev') !== -1 ? 'dev' : 'app';

// ---------------------------------------------------------
// Affiliate proxy shortlinks need the actual ROOT domain
// ---------------------------------------------------------
export const affiliate_short_link_domain = domain.search('ekno') !== -1 ? 'eknowledge.com' : 'nctpf.org';

// ---------------------------------------------------------
// Student-facing PowerPrep URL (dev or live)
// "powerprep_base_url" points to the standard,
// deployed PowerPrep instance (or local).
// Used by "Impersonate" function, to open a new tab.
// ---------------------------------------------------------
let _powerprep_base_url = 'https://';
if (window.ekno_base_url) _powerprep_base_url += `${env_subdomain}.${root_domain}`;
else _powerprep_base_url += 'local.powerprep.eknowledge.com';
export const powerprep_base_url = _powerprep_base_url;

// ---------------------------------------------------------
// Student-facing PowerPrep base URL (always LIVE)
// ---------------------------------------------------------
export const powerprep_live_domain = `app.${root_domain}`
export const powerprep_live_base_url = 'https://' + powerprep_live_domain;


export const DEV_MODE = (base_url == location.protocol + '//' + local_url || base_url.includes('dev'));
export const LIVE_MODE = !DEV_MODE;

// Use Auth.net sandbox for local (developer-machine) deploys ONLY
export const ECOMM_SANDBOX = DEV_MODE;
export const ECOMM_PRODUCTION = !ECOMM_SANDBOX;




export const base_url_audio = "";
export const base_url_icon = "";
export const base_url_image = base_url + "/webAssets/content/site_wide_media/images";
export const base_url_product_image = base_url + "/webAssets/content/site_wide_media/product_images";
export const base_url_affiliate_image = base_url + "/webAssets/content/site_wide_media/affiliate_images";
export const base_url_pdf = "";
export const base_url_text = "";
export const base_url_video = base_url + "/webAssets/content/site_wide_media/videos";


function get_powerprep_url() {

}
